import { MENU_ITEMS } from 'config/constants/menu'
import { MenuItem } from 'config/types'

export const getActiveMenuItem = ({ pathname }: { pathname: string }): MenuItem => {
  return MENU_ITEMS.reduce((result, item) => [...result, item, ...(item.subMenu || [])], [])
    .filter((menuItem) => pathname.startsWith(menuItem.route))
    .sort((item1, item2) => item2.route.length - item1.route.length)[0]
}
